import * as React from "react";
import { Slot } from "src/containers/event/event.types";
import { SlotMeta } from "./SlotMeta";
import { SlotTypeBadge } from "./SlotTypeBadge";
import { SlotLocation } from "./SlotLocation";
import { SlotSpeakers } from "./SlotSpeakers";
import { SlotInfo } from "./SlotInfo";
import { useSlotBookedOrFull } from "./useSlotBookedOrFull";
import { Checkbox } from "@ic-anywhere/ic-components";
import { noop } from "lodash-es";

interface SlotCardProps {
  slot: Slot;
  isExpanded: boolean;
  isSelected: boolean;
  onSelect: (slot: Slot) => void;
  onToggleExpand: (slotId: string) => void;
  checkboxId: string;
}

export const SlotCard: React.FC<SlotCardProps> = ({
  slot,
  isExpanded,
  isSelected,
  onSelect,
  onToggleExpand,
  checkboxId,
}) => {
  const { isBooked, isFull } = useSlotBookedOrFull(slot);
  const isBookedOrFull = isBooked || isFull;

  const handleOnSelect = (): void => {
    onSelect(slot);
  };

  const handleOnExpand = (): void => {
    onToggleExpand(slot.id);
  };

  const shouldBeChecked = (slot: Slot): boolean => {
    const { isBooked, isFull } = useSlotBookedOrFull(slot);

    if (isFull) {
      return false;
    }

    return isBooked ? !isSelected : isSelected;
  };

  return (
    <div
      className={`d-flex flex-column align-items-start py-2 px-3 gap-2 w-100 rounded mt-3 cursor bg-lvl2 ${isSelected ? "border border-info border-4" : ""}`}
      key={slot.id}
    >
      <div className="w-100 d-flex flex-column align-items-start gap-2 mb-2" onClick={!isFull ? handleOnSelect : noop}>
        {!isFull && (
          <div className="form-check">
            <Checkbox checked={shouldBeChecked(slot)} onChange={handleOnSelect} id={checkboxId} value={slot.id} />
          </div>
        )}
        <SlotMeta slot={slot} />
        <SlotTypeBadge slot={slot} />
        <div className="d-flex justify-content-between w-100 gap-4">
          <SlotLocation slot={slot} isBookedOrFull={isBookedOrFull} />
          <SlotSpeakers slot={slot} isBookedOrFull={isBookedOrFull} />
        </div>
      </div>
      <SlotInfo isExpanded={isExpanded} onToggleExpand={handleOnExpand}>
        We look forward to welcoming you to our in-person event! Please arrive 15 minutes early for registration and to
        get settled. Feel free to ask your questions and interact with the speakers during the session, and a link to
        the presentation materials will be shared afterward.
      </SlotInfo>
    </div>
  );
};
